import React from 'react';
import './css/MapNavigation.css'; // External CSS file

const MapNavigation = () => {
  return (
    <div id='map' className="map-container">
      <div className="map-header">
        <h1>OUR LOCATION</h1>
        <div className="divider"></div>
      </div>

      <div style={{ marginTop: '20px' }}>
        <iframe
          title="Seatech Infra Pvt Ltd Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.9959800927827!2d73.02278237280412!3d19.0604847006096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c3003b00ec89%3A0x2dfd73d01bc0c53b!2sSeatech%20Infra%20Pvt%20Ltd!5e1!3m2!1sen!2sin!4v1750054154220!5m2!1sen!2sin"
          width="1100"
          height="400"
          style={{ border: 0, width: '100%', height: '400px' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

      </div>
    </div>
  );
};

export default MapNavigation;
